export default {
    getPreviouslySelectedDataInChat(state){
        return state.previouslySelectedChannelOrUser;
    },
    getChatStartupData(state){
        return state.startupData;
    },
    getFirstPanelClickVal(state){
        return state.clickFirstPanel;
    },
    getAIPanelState(state){
        return state.AIPanelInfo;
    },
};
